import { AgGridReact, AgGridColumn } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";
import ButtonGroup from '@material-ui/core/ButtonGroup';

import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Modal from "@material-ui/core/Modal";

import TextField from "@material-ui/core/TextField";
import FormControlLabel from '@material-ui/core/FormControlLabel';


class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			current:"general",
			username: "",
			userid: "",
			userlastname:"",
			useremail:"",
			userage:"",
			userpassword:"",
			
		};
	}

	
	onRowSelected = event => {
		console.log(event);
		
		if (event.node.selected) {
			console.log(event.data);
			this.setState({
				rowSelected: true, 
				selectedUser: event.data.iduser
				});

		}else{
			if(this.state.selectedUser == event.data.iduser)
			{
			this.setState({
				rowSelected: false,
				selectedUser: null
				});
			}
		}
	  };


	createUsuario = () => {

		if (this.state.userid &&
			this.state.userpassword &&
			this.state.username &&
			this.state.userlastname &&
			this.state.useremail &&
			this.state.userage)
		{	
			this.props.createUser(
				this.props.token, 
				{"user":this.state.userid, 
				 "password":this.state.userpassword, 
				 "name":this.state.username, 
				 "lastname":this.state.userlastname, 
				 "email":this.state.useremail, 
				 "age":this.state.userage}
			);
			this.setState({createNew:false});
		}
	}

	exportFile = () => {
		/* convert state to workbook */
		let cols = this.props.users.map((info, i) => {
			return [
				info.nombre,
				info.apellido,
				info.email,
				info.xp,
				info.level, 
				info.totalanswers,
				info.correctanswers,
				info.totaltime, 
				info.averagetime,
				info.averagexp
			];
		});
		let hcols = [
			"Nombre",
			"Apellido",
			"E-mail",
			"XP",
			"Nivel",
			"Total Respuestas",
			"Respuestas Correctas",
			"Tiempo Total",
			"Tiempo Promedio",
			"XP Promedio"
		];

		const exp = [[...hcols], ...cols];
		const ws = XLSX.utils.aoa_to_sheet(exp);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Usuarios");
		/* generate XLSX file and send to client */
		XLSX.writeFile(wb, "Usuarios.xlsx");
	};

	handleDelete = () => {
		this.props.deleteUser(this.props.token, this.state.selectedUser);
		this.setState({
			deleteModal:false
		});
	}


	componentDidMount() {

	}

	render() {
		return (
			<React.Fragment>
			{ this.state.deleteModal ? 
            <Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.deleteModal}
				>
					<Paper
						style={{
							display: "grid",
							width: "500px",
							padding: "25px",
                            margin: "20% auto",
                            height: "200px",
                            overflowY: "auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
						<br />
						<br />
							<b>Seguro desea borrar? </b>
							<br /><br /><br />
                    
								<Button
								onClick={this.handleDelete}
								type="submit"
								color="primary"
								variant="contained"
							>
								Borrar
							</Button>
						
							
							&nbsp;&nbsp;&nbsp;
							<Button onClick={()=>{this.setState({deleteModal:false})}} color="primary">
								Cancelar
							</Button>
						
						</div>
					</Paper>
				</Modal>
				: null }

				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.createNew}
				>
					<Paper
						style={{
							display: "grid",
							width: "60%",
							padding: "25px",
                            margin: "auto auto",
                            height: "58%",
                            overflowY: "auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							<h2>Crear Usuario</h2>
							<br />
                            <TextField
								id="standard-select"
								label="Usuario ID"
								variant="outlined"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.userid}
								onChange={value =>{this.setState({ userid: value.target.value });}}
							>
							</TextField>
							<br />
							<TextField
								id="standard-select"
								label="Password"
								variant="outlined"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.userpassword}
								onChange={value =>{this.setState({ userpassword: value.target.value });}}
							>
							</TextField>
							<br />
                            <TextField
								id="standard-select"
								label="Nombre"
								variant="outlined"
								style={{
									marginBottom: "20px",
                                 	width: "90%",
									textAlign: "left"
								}}
								value={this.state.username}
								onChange={value =>{this.setState({ username: value.target.value });}}
							>
							</TextField>
							<br />
                            <TextField
								id="standard-select"
								label="Apellido"
								variant="outlined"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.userlastname}
								onChange={value => {this.setState({ userlastname: value.target.value })}}
							>
							</TextField>
							<br />
                            <TextField
								id="standard-select"
								label="Email"
								variant="outlined"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.useremail}
								onChange={value =>this.setState({ useremail: value.target.value })}
							>
							</TextField>
                            <br />
                            <TextField
								id="standard-select"
								label="Edad"
								variant="outlined"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.userage}
								onChange={value =>this.setState({ userage: value.target.value })}
							>
							</TextField>
							<br />
							
							<Button onClick={this.createUsuario} type="submit" color="primary" variant="contained" >
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button onClick={()=>{this.setState({createNew: false});}} color="primary">
								Cancelar
							</Button>
							<br />
						</div>
					</Paper>
				</Modal>



				<h2 style={{ width: "100%", textAlign: "left" }}>Usuarios</h2>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					
					{"  "}
					<Button
						onClick={()=>{this.setState({createNew: true});}}
						color="primary"
						variant="contained"
					>
						Crear Usuario
					</Button>
					{" "}
					{ this.state.rowSelected ? 
					<Button
						onClick={()=>{this.setState({deleteModal: true})}}
						color="primary"
						variant="contained"
					>
						Borrar
					</Button>
					:null}
				</div>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					<ButtonGroup size="large" color="primary" aria-label="outlined primary button group">
						<Button variant={this.state.current === "general" ? "contained" : "outlined"} onClick={()=>{this.props.loadUsersGeneral(this.props.token);this.setState({current:"general"});}}>General</Button>
						<Button variant={this.state.current === "month" ? "contained" : "outlined"}  onClick={()=>{this.props.loadUsersMonth(this.props.token);this.setState({current:"month"});}}>Mes</Button>
						<Button variant={this.state.current === "week" ? "contained" : "outlined"}  onClick={()=>{this.props.loadUsersWeek(this.props.token);this.setState({current:"week"});}}>Semana</Button>
					</ButtonGroup>
					<div style={{ float: "right" }}>

					<Button
							onClick={this.exportFile}
							color="primary"
							variant="contained"
						>
							Exportar a Excel
						</Button>
					</div>
				</div>
				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "100%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.users  ? this.props.users : null}
						rowSelection="single"
						onRowSelected={this.onRowSelected}
						onSelectionChanged={this.onSelectionChanged}
					>
						<AgGridColumn
					headerName="#"
					width={40}
					checkboxSelection
					suppressSorting
					suppressMenu
					suppressFilter
					pinned
					/>
					<AgGridColumn headerName="Usuario" field="username" width={100} />
					<AgGridColumn headerName="Nombre" field="name" width={100} />
					<AgGridColumn headerName="Apellido" field="lastname" width={100} />

					<AgGridColumn headerName="Edad" field="age" width={100} />

					<AgGridColumn headerName="Email" field="email" width={150} />
					<AgGridColumn headerName="Xp" field="xp" width={80} />
					<AgGridColumn headerName="Nivel" field="level" width={80} />
					<AgGridColumn headerName="Total Respuestas" field="totalanswers" width={130} />
					<AgGridColumn headerName="Respuestas Correctas" field="correctanswers" width={130} />
					<AgGridColumn headerName="Tiempo Total" field="totaltime" width={100} />
					<AgGridColumn headerName="Tiempo Promedio" field="averagetime" width={100} />
					<AgGridColumn headerName="XP Promedio" field="averagexp" width={100} />

					</AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Users;
